import { Input } from '@chakra-ui/react';

export default function VInput({ variant = 'outline', size = 'xs', readOnly = false, ...props }) {
  return (
    <Input
      size={size}
      variant={variant}
      _readOnly={{ cursor: 'not-allowed' }}
      _disabled={{ bg: 'bg.muted', opacity: 1 }}
      {...(readOnly && { readOnly: 'readOnly' })}
      {...props}
    />
  );
}
